/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const ProgressBarBackground = styled.div`
  width: 100%;
  border-radius: 8px;
  height: 12px;
  position: relative;
  overflow: hidden;
`;

export const ProgressBarRatio = styled.div<{ duration: number }>`
  border-radius: 8px;
  position: absolute;
  height: 12px;
  transition: width ${(props) => props.duration}s;
  transition-timing-function: ease-in;
`;

export const IconWrapper = styled.div`
  position: absolute;
`;
